"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userIdSelector = exports.defaultDealershipIdSelector = exports.userProfileSelector = exports.accessTokenSelector = exports.releasePoolSelector = exports.dealershipIdSelector = void 0;

var _reselect = require("reselect");

var _appSettings = require("../../utils/app-settings.util");

var _isMock = require("../../utils/is-mock");

var _isShell = require("../../utils/is-shell");

var _lifecycle = require("./lifecycle.reducer");

var lifecycleSelector = _lifecycle.lifecycleReducer.sliceSelector;

var oidcSelector = function oidcSelector(state) {
  return state.oidc;
};

var dealershipIdSelector = (0, _reselect.createSelector)(lifecycleSelector, _isShell.isInShellSelector, function (lifecycle, isInShell) {
  var settings = (0, _appSettings.getAppSettings)();

  if (settings && settings.isStorybook) {
    return settings.mockDealershipId;
  }

  var result = 0;

  if (isInShell) {
    result = lifecycle.dealershipId;
  } else if (settings) {
    result = settings.mockDealershipId;
  }

  return result;
});
exports.dealershipIdSelector = dealershipIdSelector;
var releasePoolSelector = (0, _reselect.createSelector)(lifecycleSelector, function (lifecycle) {
  return lifecycle.releasePool;
});
exports.releasePoolSelector = releasePoolSelector;
var accessTokenSelector = (0, _reselect.createSelector)(lifecycleSelector, oidcSelector, _isShell.isInShellSelector, function (lifecycle, oidc, isInShell) {
  var settings = (0, _appSettings.getAppSettings)();

  if (settings && settings.isStorybook) {
    // Todo: deprecate mockToken
    return settings.mockToken || settings.mockAccessToken;
  }

  var token;

  if (isInShell) {
    token = lifecycle.accessToken;
  } else if (oidc.user) {
    token = oidc.user.access_token;
  }

  if (!token && _isMock.isMock) {
    if (settings) {
      token = settings.mockAccessToken;
    }
  }

  return token;
});
exports.accessTokenSelector = accessTokenSelector;
var userProfileSelector = (0, _reselect.createSelector)(lifecycleSelector, oidcSelector, _isShell.isInShellSelector, function (lifecycle, oidc, isInShell) {
  var settings = (0, _appSettings.getAppSettings)();

  if (settings && settings.isStorybook) {
    return settings.userProfile;
  }

  var profile;

  if (isInShell) {
    profile = lifecycle.userProfile;
  } else if (oidc && oidc.user) {
    profile = oidc.user;
  }

  if (!profile && _isMock.isMock) {
    if (settings) {
      return settings.userProfile;
    }
  }

  return profile;
});
exports.userProfileSelector = userProfileSelector;
var defaultDealershipIdSelector = (0, _reselect.createSelector)(lifecycleSelector, oidcSelector, _isShell.isInShellSelector, function (lifecycle, oidc, isInShell) {
  var dealershipId;

  if (isInShell) {
    dealershipId = lifecycle.userProfile ? lifecycle.userProfile.defaultDealershipId : 0;
  } else if (oidc && oidc.user) {
    dealershipId = oidc.user.defaultDealershipId;
  }

  return dealershipId;
});
exports.defaultDealershipIdSelector = defaultDealershipIdSelector;
var userIdSelector = (0, _reselect.createSelector)(lifecycleSelector, oidcSelector, _isShell.isInShellSelector, function (lifecycle, oidc, isInShell) {
  var userId;

  if (isInShell) {
    userId = lifecycle.userProfile ? lifecycle.userProfile.id : 0;
  } else if (oidc && oidc.user) {
    userId = oidc.user.id;
  }

  return userId;
});
exports.userIdSelector = userIdSelector;